// extracted by mini-css-extract-plugin
export var discription = "index-module--discription--493f7";
export var root = "index-module--root--76035";
export var title = "index-module--title--53146";